import { EventListener } from "@/dataprocessor/event-listener";
import { Search } from "./types";
import { DataProvider } from "./dataProvider";
import { InferenceSetup } from "@/inference/setup";
import { preparePayload } from "@/inference/utils/payload";
import { Init } from "./init";
// if (!window.helium.brandData) throw new Error("brandData not found in window");
import { handleUiScript } from "@/ui-sdk/ui-script";
import { PersonaTertiaryAttributes } from "@/inference/engine/attributes/persona/types";
import { ViewTimeInference } from "@/dataprocessor/view-time";
import { ScoringHandler } from "@/dataprocessor/scoring";
import { memoryOperations } from "./memory";

if (!window.helium.brandData) throw new Error("brandData not found in window");

export class DataStore {
  static get instance(): DataStore {}

  static memory = {};
  static memoryStore = memoryOperations;
  static current = {
    get page() {
      return DataStore.memory.page[window.location.pathname];
    },
    get product() {
      return DataStore.memory.product[
        window.location.pathname.split("/").at(-1) as string
      ];
    },
    get tags() {
      return DataStore.memory.product[
        window.location.pathname.split("/").at(-1) as string
      ].tags;
    },
    get brand() {
      return DataStore.memory.brand;
    },
    get user() {
      return DataStore.memory.user;
    },
    get cart() {
      return DataStore.memory.cart;
    },
    get info() {
      Init.initPageData();
      return {
        productPageFilters: {
          primaryColor:
            DataStore.current?.product?.tags?.tags?.physical?.colour?.primary
              ?.value ?? "",
          pattern:
            DataStore?.current?.product?.tags?.tags?.physical?.pattern ?? "",
          material:
            DataStore?.current?.product?.tags?.tags?.physical?.material ?? "",
        },
      };
    },
    get productList() {
      // const searchParamsObject = getSearchParamsAsObject();
      return DataStore.memory.filters.products;
    },
  };

  static getSectionScores(): Record<string, number> {
    const sectionScores = Object.keys(
      ScoringHandler.Product.getProductScores(),
    ).map((e) => [e, ScoringHandler.Product.computeScore(e)]);

    return Object.fromEntries(sectionScores);
  }

  static getCleanInference(): Record<string, number> {
    return preparePayload(InferenceSetup.getInferenceFromLocalStorage() || {})
      .flattenedPayload;
  }

  static getFilterData() {
    const filterStrings = [
      "tags.visual.material",
      "tags.visual.pattern",
      "tags.visual.color.primary.value",
    ];
    const filterStringToFilterMapping = {
      "tags.visual.material": "material",
      "tags.visual.pattern": "pattern",
      "tags.visual.color.primary.value": "primaryColor",
    };
    // if (false)
    //   return [
    //     {
    //       type: "primaryColor",
    //       value: "navy",
    //       points: 195,
    //     },
    //     {
    //       type: "primaryColor",
    //       value: "blue",
    //       points: 188,
    //     },
    //     {
    //       type: "primaryColor",
    //       value: "red",
    //       points: 182,
    //     },
    //     {
    //       type: "material",
    //       value: "cotton",
    //       points: 958,
    //     },
    //     {
    //       type: "material",
    //       value: "polyester",
    //       points: 127,
    //     },
    //     {
    //       type: "material",
    //       value: "spandex",
    //       points: 64,
    //     },
    //     {
    //       type: "pattern",
    //       value: "solid",
    //       points: 472,
    //     },
    //     {
    //       type: "pattern",
    //       value: "textured",
    //       points: 163,
    //     },
    //     {
    //       type: "pattern",
    //       value: "striped",
    //       points: 43,
    //     },
    //   ];
    const inference = this.getCleanInference();
    console.log({ inference });
    const obj = {};
    const entries = Object.entries(inference).forEach(([key, value]) => {
      return filterStrings.forEach((filterString) => {
        if (value < 40) return;
        if (key.includes(filterString)) {
          if (!obj[filterString]) obj[filterString] = [];
          obj[filterString].push({
            type: filterStringToFilterMapping[filterString],
            value: key.split(".").at(-1),
            points: value,
          });
          return true;
        }
      });
    });
    const filterData = [];
    Object.keys(obj)
      .map((key) => {
        obj[key] = obj[key].sort((a, b) => b.points - a.points).slice(0, 3);
        return key;
      })
      .map((key) => {
        const data = obj[key];
        filterData.push(...data);
      });
    return filterData;
  }

  static getCleanNestedTags() {
    const inference = preparePayload(
      InferenceSetup.getInferenceFromLocalStorage() || {},
      true,
    );

    return inference.filteredPayload?.sectionInferenceAttributes;
  }

  static getCategorySpecificInference() {
    return ViewTimeInference.categorySpecificScore || {};
  }

  static getCleanNestedDemographicInference() {
    const inference = preparePayload(
      InferenceSetup.getInferenceFromLocalStorage() || {},
    ).filteredPayload?.sectionInferenceAttributes?.demographics as Partial<
      PersonaTertiaryAttributes["demographic"]
    >;

    const denominator = Object.keys(ViewTimeInference.seenSection).length || 1;

    if (denominator === 1) return inference;

    Object.keys(inference || {}).forEach((key) => {
      const subKeys = Object.keys(inference[key]);

      // TODO: Replace this with a softmax
      subKeys.forEach((subKey) => {
        inference[key][subKey] = +(
          inference[key][subKey] / denominator
        ).toFixed(2);
      });
    });

    return inference;
  }

  static dataProvider = DataProvider;
  static getInstance() {}
  static async init() {
    if (!window.helium) {
      window.helium = {} as Window["helium"];
    }
    window.helium.datastore = DataStore;

    // Load active memory from session storage

    await Init.init();
  }
  static async refresh(navigation: boolean) {
    if (window.helium.brandData.isPro) {
      if (!navigation) handleUiScript();
    }

    if (navigation) {
      window.helium?.onPageChange?.();
    }
    //if (navigation) {
    DataStore.onNavigate();
    //}
  }
  static async onNavigate() {
    Init.initPageData();
    EventListener.interactionObservers();
    EventListener.viewtimeIntersectionObservers();
    InferenceSetup.tagPageElements(true);
  }
  static async unload() {
    memoryOperations.persistToLocalStorage();
  }
  static async getBrandData() {
    return DataStore.memory.brand;
  }
  static async getPageInfo({ id }: { id: string }) {
    return DataStore.memory.page[id];
  }

  static async getProduct({ id }: { id: string }) {
    await this.dataProvider.getDetails({ id });
    return DataStore.memory.product[id];
  }

  static async getProducts() {
    await this.dataProvider.getProducts();
    return DataStore.memory.list.products;
  }
  static async getTags({ id }: { id: string }) {
    await this.dataProvider.getTags({ id, mode: "product" });
    return DataStore.memory.product[id]?.tags;
  }
  static async getUiDescription({ id }: { id: string }) {
    await this.dataProvider.getUiDescription({ id, mode: "product" });
    return DataStore.memory.product[id]?.uiDescription;
  }
  static async getTagRecommendation({ id }: { id: string }) {
    await this.dataProvider.getTagRecommendation({ id, mode: "product" });
    return DataStore.memory.product[id]?.tagRecommendation;
  }
  static async getFaq({ id }: { id: string }) {
    await this.dataProvider.getFaq({ id, mode: "product" });
    return DataStore.memory.product[id]?.faq;
  }
  static async getSectionsTags({ sections }: { sections: string[] }) {
    await this.dataProvider.getSectionsTags({ sections });
    return DataStore.memory.section;
  }

  static async getSimilar({ id }: { id: string }) {
    await this.dataProvider.getSimilar({ id });
    return DataStore.memory.product[id]?.similar;
  }

  static async getComplementary({ id }: { id: string }) {
    await this.dataProvider.getComplementary({ id });
    return DataStore.memory.product[id]?.complementary;
  }

  static async getSectionTag({ id }: { id: string }) {
    await this.dataProvider.getTags({ id, mode: "section" });
    return DataStore.memory.tag?.section?.[id];
  }

  static async search({ query, filterKeys, ignoreHandle }: Search) {
    await this.dataProvider.search({
      query,
      filterKeys,
      ignoreHandle,
    });
    return DataStore.current.productList;
  }
}
window.helium.datastore = DataStore;
function nullPredicate(value: any) {
  return Boolean(value);
}

function convertSearchParamsToObject(): Record<string, string> {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsObject: Record<string, string> = {};
  urlParams.forEach((value, key) => {
    paramsObject[key] = value;
  });
  return paramsObject;
}

function ensureInit() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => DataStore.init());
  } else {
    DataStore.init();
  }
}
ensureInit();

window.addEventListener("reinitialize-helium", () => DataStore.init());

window.addEventListener("beforeunload", () => {
  memoryOperations.persistToLocalStorage();
});
